'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var urls = exports.urls = {
  register: 'https://www.tutellus.com/registro',
  courses: 'https://www.tutellus.com/cursos/',
  affiliate: 'https://affiliate.tutellus.com',
  affiliate_terms: 'https://www.tutellus.com/informacion/api-for-affiliates',
  corporate: 'https://www.tutellus.com/informacion/corporate',
  unlimited: 'https://www.tutellus.com/informacion/unlimited',
  channels_universities: 'https://www.tutellus.com/canales/universidades/',
  channels_universities_create: 'https://www.tutellus.com/canales/universidad/create',
  channels_organizations: 'https://www.tutellus.com/canales/organizaciones/',
  channels_organizations_create: 'https://www.tutellus.com/canales/organizacion/create'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/urls.js
// module id = 705
// module chunks = 0